import { render, staticRenderFns } from "./ViewMethodEthicsAndDissemination.vue?vue&type=template&id=7d84d00a&"
import script from "./ViewMethodEthicsAndDissemination.vue?vue&type=script&lang=js&"
export * from "./ViewMethodEthicsAndDissemination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports